/**
 *
 *  Created by Vladimir Shishlyannikov on 01/03/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import { useState, useEffect } from "react";

export const useIntersectionObserver = (params = {}, deps) => {
  const {
    onIntersect,
    root,
    disconnect,
    target, // eslint-disable-line
    threshold,
    rootMargin,
    trackVisibility, // eslint-disable-line
    delay,
    triggerOnce,
  } = params;
  const initialInView = params.initialInView;
  const [_inView, setInView] = useState(
      initialInView !== null && initialInView !== undefined && initialInView
    ),
    [entry, setEntry] = useState(undefined),
    [targetRef, setTargetRef] = useState(undefined);

  useEffect(() => {
    if ((!disconnect || !disconnect()) && targetRef != null) {
      var e = {
          root: root ? root : null,
          rootMargin,
          threshold,
          delay,
        },
        observer = new IntersectionObserver((entries) => {
          const _entry = entries[0];

          window.requestAnimationFrame(() => {
            if (_entry.isIntersecting) {
              setInView(true);
            }

            setEntry(_entry);
          });

          _entry.isIntersecting && triggerOnce && observer.disconnect();
        }, e);

      observer.observe(targetRef);

      // Clean up
      return () => observer.disconnect();
    }
  }, [...deps, onIntersect, root, threshold, rootMargin, targetRef]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const _initialInView = !!params.initialInView;

    if (
      !(
        (targetRef || entry == null || !entry.target,
        triggerOnce) /* || u.skip*/
      )
    ) {
      setInView(
        _initialInView !== null &&
          _initialInView !== undefined &&
          _initialInView
      );
      setEntry(undefined);
    }
  }, [targetRef, entry, triggerOnce, /*u.skip, */ params.initialInView]);

  return {
    ref: setTargetRef,
    inView: _inView,
    entry,
  };
};
